import { ApplicationState } from 'ducks/application-state';

export const selectProfile = (state: ApplicationState) => state.user.profile;
export const selectUser = (state: ApplicationState) => state.user.user;
export const selectUsers = (state: ApplicationState) => state.user.list;
export const selectUsersPagination = (state: ApplicationState) => state.user.pagination;
export const selectUsersSort = (state: ApplicationState) => state.user.sort;
export const selectUserLoading = (state: ApplicationState) => state.user.loading;
